const { isSmartPhone, createInquiryUrl, isProduction, changeToCustomHTML, convertZoning, } = require('./utils/utils')

module.exports = { isSmartPhone, createInquiryUrl, isProduction, changeToCustomHTML, convertZoning, }
